import { createContext, type Dispatch, type SetStateAction } from 'react';
import type { IGetPlayerWithOrganizationsQuery } from 'src/graphql/queries/players.graphql.types';

export type TModal = '' | 'login' | 'forgotPassword' | 'resetPassword';

type TRootUserWithValidation = IGetPlayerWithOrganizationsQuery['user'] & {
  isValidated: boolean;
  activeModal: TModal;
  modalArgs: Record<string, string>;
  inspectedPlayerId: number;
};

export type TRootUserContext = {
  rootUser: TRootUserWithValidation;
  setRootUser: Dispatch<SetStateAction<TRootUserWithValidation>>;
};

export const initialState = {
  __typename: 'User' as const,
  userOrganization: null,
  id: 0,
  fullName: '',
  firstName: '',
  lastName: '',
  preferredName: '',
  emailAddress: '',
  organizations: [],
  isValidated: false,
  activeModal: '' as TModal,
  modalArgs: {} as Record<string, string>,
  inspectedPlayerId: 0,
} as TRootUserWithValidation;

const RootUserContext = createContext<TRootUserContext>({
  rootUser: initialState,
  // biome-ignore lint/suspicious/noEmptyBlockStatements: TODO: explain
  setRootUser: () => {},
});

export default RootUserContext;
